import React, { useState, useRef, useEffect } from 'react'
import { Input, Tree } from '@ow/comps'
import { SearchIcon, IconMaps } from '@ow/icons'
import { useNavigate } from 'react-router-dom'
import { cloneDeep, pick } from 'lodash-es'
import { css, Global } from '@emotion/react'
// import { vidDataMap } from '@ow/mocks/lib/2021-12/nmgVidMap'
import { useAppEx } from '@vt/hooks'
// import { useAppEx, authContext } from '@vt/hooks'
import { getQuery } from '@vt/utils'
import { useNavStore } from '@vt/comps'
import useRouteTo from '../../hooks/navigation/use-route-to'
// import treeData from '@ow/mocks/lib/2021-12/tree'
// import { fetchLeftTreeData } from '@vt/apis/lib-ex/v2/organization'

const Icon = function (icon) {
  return (
    <div
      style={{
        display: 'inline-block',
        marginRight: '-6px',
        marginTop: '5px',
        width: '16px',
        height: '16px',
      }}
    >
      <IconMaps type={icon} width={16} height={16} size={16} />
    </div>
  )
}

const treeToArray = (tree) => {
  return tree.reduce((res, item) => {
    const { children, ...i } = item
    return res.concat(
      i,
      children && children.length ? treeToArray(children) : []
    )
  }, [])
}

const TreeNav = function ({ treeData }) {
  // const TreeNav = function ({ purpose }) {
  // const { treeData } = data202112
  const [allTreeData, setAllTreeData] = useState()
  const [tree, setTreeData] = useState()
  const [expandKeys, setExpandKeys] = useState([])
  const inputRef = useRef()

  const { appId } = useAppEx()
  const { routeTo } = useRouteTo({ appId })
  const navigate = useNavigate()
  // const { token } = useContext(authContext)
  const { treeKey = '' } = getQuery()

  // 查找所有父级元素treeKey
  const getTreeParentIds = (tree_data, nodeId, config) => {
    const { children = 'children', id = 'treeKey' } = config || {}
    const toFlatArray = (data, parentId) => {
      return data.reduce((prev, item) => {
        const child = item[children]
        return [
          ...prev,
          parentId ? { ...item, parentId } : item,
          ...(child && child.length ? toFlatArray(child, item[id]) : []),
        ]
      }, [])
    }
    const getIds = (flatArray) => {
      let ids = [nodeId]
      let child = flatArray.find((f) => f[id] === nodeId)
      if (child && child.parentId) {
        ids = [child.parentId, ...ids]
        child = flatArray.find((f) => f[id] === child.parentId)
      }
      return ids
    }
    return getIds(toFlatArray(tree_data))
  }

  const {
    setCurrentNav,
    treeInputValue,
    setTreeInputValue,
    isRefreshTree,
    setIsRefreshTree,
  } = useNavStore((state) =>
    pick(state, [
      'setCurrentNav',
      'treeInputValue',
      'setTreeInputValue',
      'isRefreshTree',
      'setIsRefreshTree',
    ])
  )

  // const { orgSlug } = userInfoInApp
  // 获取默认展开的目录
  const tag = ','
  const urlDefaultKey = treeKey.length ? treeKey.split(tag) : []
  const [defaultKeys, setDefaultKeys] = useState(urlDefaultKey)

  const filterTree = (data, valueAry) => {
    const _data = cloneDeep(data)
    return _data.filter(function iter(node) {
      let temp = []
      if (node.name.indexOf(valueAry) !== -1) {
        return true
      }
      if (!Array.isArray(node.children) || node.children.length === 0) {
        return false
      }
      temp = node.children.filter(iter)
      if (temp.length) {
        node.children = temp
        return true
      }
      return false
    })
  }

  const search = (value) => {
    // 此处写Promise的原因是:
    // defaultExpandedKeys 在初始化时才生效。 要让 tree 组件重新加
    // 直接写不会产生数据变化，Promise异步后数据才会变化触发 tree 组件再加载
    Promise.resolve(setTreeData(null), setDefaultKeys(null)).then(() => {
      if (value && value !== '') {
        setTreeData(filterTree(allTreeData, value))
        const defaultCheckNode = treeToArray(filterTree(allTreeData, value))
        setDefaultKeys(defaultCheckNode.map((node) => node.treeKey))
      } else {
        setTreeData(allTreeData)
        setDefaultKeys(urlDefaultKey)
      }
    })
  }

  useEffect(() => {
    // 此处写Promise的原因是:
    // 两个界面用的同一个路由，tree
    // defaultExpandedKeys 在初始化时才生效。 要让 tree 组件重新加
    // 直接set修改值为null不会产生数据变化，Promise异步后数据才会变化触发 tree 组件再加载
    Promise.resolve(setTreeData(null), setDefaultKeys(null)).then(() => {
      if (appId) {
        setAllTreeData(treeData)
        // setTreeData(treeData)
        if (treeInputValue) {
          search(treeInputValue)
        } else {
          setTreeData(treeData)
          setDefaultKeys(urlDefaultKey)
        }
      }
    })
  }, [treeData])
  useEffect(() => {
    if (isRefreshTree) {
      setExpandKeys(getTreeParentIds(treeData, treeKey))
    }
    setIsRefreshTree(false)
  }, [isRefreshTree])

  return (
    <div
      style={{
        backgroundColor: '#fff',
        width: '289px',
        height: '100%',
      }}
    >
      <Global
        styles={css`
          .rc-tree {
            padding: 0px 0.5rem 1rem 0.5rem;
            width: 100%;
            height: calc(100% - 3.75rem);
            overflow: auto;
          }
          .rc-tree-title {
            width: 14em;
          }
          .rc-tree-node-selected {
            font-weight: 600;
          }
        `}
      />
      <div className="mx-2 mt-4 h-8 mb-3 flex justify-between items-center border rounded border-gray-300">
        <Input
          placeholder="请输入名称, 回车搜索"
          ref={inputRef}
          style={{
            border: 'none',
            height: '30px',
            outline: 'none',
            boxShadow: 'none',
          }}
          onChange={(e) => {
            const { value } = e.target
            setTreeInputValue(value)
            if (value === '') {
              setTreeData(tree)
            }
          }}
          onPressEnter={(e) => {
            search(e.target.value)
          }}
          value={treeInputValue}
        />

        <div
          className="mr-2"
          onClick={() => {
            const { value } = inputRef.current
            search(value)
          }}
        >
          <SearchIcon width={16} height={16} />
        </div>
      </div>
      {tree && defaultKeys && (
        <Tree
          data={tree}
          className="text-sm text-gray-600"
          // showIcon={false}
          icon={(item) => {
            console.log(item, 'iconiconicon')
            return Icon(item.icon)
          }}
          defaultSelectedKeys={urlDefaultKey}
          label="name"
          ckey="treeKey"
          titleLength={12}
          checkedKeys={defaultKeys}
          expandedKeys={expandKeys}
          onExpand={(keys) => {
            setExpandKeys(keys)
          }}
          onSelect={(key, { node }) => {
            if (
              key &&
              !node.children &&
              !node.extData.route.url.includes('undefined')
            ) {
              setCurrentNav(node.extData.route)
              routeTo(node.extData.route, appId, navigate)
            }
            // if (tbId && vid) {
            //   console.log('tbId:', tbId, ' vid:', vid)
            //   routeTo(key)
            //   routeTo(
            //     {
            //       url: `/cp/${
            //         process.env.REACT_APP_PROJECT
            //       }/apps/${appId}/tbs/${tbId}?vid=${vid}&tpl=${tpl}&token=${token}&treeKey=${key.join(
            //         tag
            //       )}&purpose=${purpose}`,
            //       navType: 'push',
            //     },
            //     appId,
            //     navigate
            //   )
            // } else {
            //   console.log('tbId，vid没有找到，tbId，vid:', tbId, vid)
            // }
          }}
          setExtData={(item) => {
            return { route: item }
          }}
        />
      )}
    </div>
  )
}

export default TreeNav
